import { useState } from "react";
import { AuthProvider, useAuth } from "./auth";
import { Login } from "./Login";
import { Creator } from "./Creator";
import { RecipeList } from "./components/RecipeList";
import { RecipeRunner } from "./components/RecipeRunner";
import { RecipeCreator } from "./components/RecipeCreator";
import { JobStatus } from "./components/JobStatus";

type Job = { id: string; label: string };

export function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}

function Gate() {
  const { state } = useAuth();
  if (state.status === "checking") {
    // Blank shell rather than "Loading…" — the auth probe usually completes in
    // a handful of ms, and showing nothing avoids a flash of UI before the
    // login card or app lands.
    return <div className="public-shell" />;
  }
  if (state.status === "anonymous") {
    return <Login />;
  }
  return <Home />;
}

function Home() {
  const { state, logout } = useAuth();
  const [jobs, setJobs] = useState<Job[]>([]);

  function trackJob(job: Job) {
    setJobs((prev) => [job, ...prev.filter((j) => j.id !== job.id)]);
  }

  const username = state.status === "authenticated" ? state.user.username : "";

  return (
    <div className="app">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <div>
          <h1>recipe-runtime</h1>
          <div className="muted">
            list / run / create recipes — backed by Modal + R2 + Postgres
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div className="muted">signed in as {username}</div>
          <button
            style={{ marginTop: 4, background: "transparent", color: "#374151", padding: "4px 8px", border: "1px solid #d1d5db" }}
            onClick={() => void logout()}
          >
            Sign out
          </button>
        </div>
      </div>

      <h2>Registry</h2>
      <RecipeList />

      <h2>Plan a new recipe</h2>
      <Creator />

      <h2>Run a recipe</h2>
      <RecipeRunner onSpawned={(id) => trackJob({ id, label: `run · ${id.slice(0, 8)}` })} />

      <h2>Create a recipe (direct, single-shot)</h2>
      <RecipeCreator
        onSpawned={(id, targetId) =>
          trackJob({ id, label: `create · ${targetId} · ${id.slice(0, 8)}` })
        }
      />

      {jobs.length > 0 && (
        <>
          <h2>Jobs</h2>
          {jobs.map((j) => (
            <JobStatus key={j.id} jobId={j.id} label={j.label} />
          ))}
        </>
      )}
    </div>
  );
}
